import Config from "services/config/config";
import dateFormatReverse from "constants/dateformatReverse";
import callWebService, { callTypes, showToast } from "services/utils/networks/network";
import { MRF_DETAILS, MRF_DETAILS_BY_GATE } from "./type";

const toApiDate = (value) => {
  if (!value || value === "Invalid date") return undefined;
  if (/^\d{2}-\d{2}-\d{4}$/.test(value)) return dateFormatReverse(value);
  return value;
};

export const getMrfDetails = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.installation.mrfDetail}?site_id=${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: MRF_DETAILS, payload: data.response.data });
    return data.response.data;
  }
};

export const postReportDetails = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.installation.addReportDetails}`
  );
  if (res) {
    const { data } = res;
    return data.response.status;
  }
};

export const postApproval = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    "",
    `${Config.installation.sendApproval}?site_id=${id}`
  );
  if (res) {
    const { data } = res;
    return data.response.status;
  }
};

const parseGenerateReportResponse = (body) => {
  if (!body || Number(body.status) !== 0) {
    return { success: false, message: body?.message || "" };
  }

  const reportData = body.data;
  const isAsyncJob =
    reportData &&
    typeof reportData === "object" &&
    !Array.isArray(reportData) &&
    reportData.report_status;

  return {
    success: true,
    message: body.message || "",
    reportStatus: isAsyncJob ? reportData.report_status : "completed",
    jobId: isAsyncJob ? reportData.job_id : null,
  };
};

const toManualInvoices = (rows) => {
  if (!Array.isArray(rows)) return [];
  return rows
    .map((row) => ({
      invoice_number: (row?.invoice_number || "").trim(),
      billing_start_date: toApiDate(row?.billing_start_date),
      billing_end_date: toApiDate(row?.billing_end_date),
    }))
    .filter(
      (row) =>
        row.invoice_number && row.billing_start_date && row.billing_end_date
    );
};

export const generateReport = (data) => async () => {
  const handoverDate = toApiDate(data?.handover_date);
  const invoiceData = toManualInvoices(data?.invoice_data);
  const payload = {
    site_id: data?.site_id ?? data?.id,
    stage_id: data?.stage_id,
    ...(data?.passCode !== undefined && { passCode: data.passCode }),
    ...(data?.fileAttached !== undefined && { fileAttached: data.fileAttached }),
    ...(handoverDate && { handover_date: handoverDate }),
    ...(invoiceData.length ? { invoice_data: invoiceData } : {}),
  };

  try {
    const res = await callWebService(
      callTypes.post,
      payload,
      `${Config.installation.generateReport}`
    );
    return parseGenerateReportResponse(res?.data);
  } catch (error) {
    if (error?.message) {
      showToast({ data: { message: error.message } });
    }
    return {
      success: false,
      message: error?.message || "",
    };
  }
};

export const previewHandoverValetContract = (data) => async () => {
  const payload = {
    contract_id: Number(data?.contract_id),
    handover_date: toApiDate(data?.handover_date),
    invoice_data: toManualInvoices(data?.invoice_data),
  };

  const res = await callWebService(
    callTypes.post,
    payload,
    Config.installation.handoverValetContractPreview
  );
  const body = res?.data;
  if (body && Number(body.status) === 0 && body.valid !== false && body.data) {
    return { success: true, data: body.data };
  }
  if (res?.status === 200 && Number(body?.status) !== 1) {
    showToast({
      data: { message: body?.message || "Unable to preview handover invoices." },
    });
  }
  return { success: false, message: body?.message || "" };
};

export const postSendProcurement = (id, stageId, remarks = '') => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
      {remarks:remarks},
    `${Config.installation.sendtoProcurement}?site_id=${id}&stage_id=${stageId}`
  );
  if (res) {
    const { data } = res;
    return data.response.status;
  }
};

export const getMrfDetailsByGate = (id, gateId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.installation.mrfViewGateWise}?site_id=${id}&gate_id=${gateId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: MRF_DETAILS_BY_GATE, payload: data.response.data });
    return data.response.data;
  }
};

export const deleteMrfDetail = (id) => async () => {
  const res = await callWebService(
    callTypes.delete,
    "",
    `${Config.installation.deleteMrf}?id=${id}`
  );
  if (res) {
    const { data } = res;
    return data.response.data;
  }
}

export const updateMrfDetails = (data) => async () => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.installation.editMrf}`
  );
  if (res) {
    const { data } = res;
    return data.response.data;
  }
} 
